import axios from "axios";
import { useAuth } from "@clerk/react";
import { useMemo, useRef } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  const ref = useRef(getToken);
  ref.current = getToken;
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (c) => {
      const t = await ref.current();
      if (t) c.headers.Authorization = `Bearer ${t}`;
      return c;
    });
    return inst;
  }, []);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(", ");
  return e?.message || "Something went wrong";
};
export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const dt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "-");
export const dOnly = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "-");
export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
export const todayIST = () => new Date(Date.now() + 5.5 * 3600e3).toISOString().slice(0, 10);

export async function download(api, path, name) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const PERMS = {
  view: ["admin", "manager", "cashier", "warehouse"],
  "products.edit": ["admin", "manager"],
  "inventory.edit": ["admin", "manager", "warehouse"],
  purchase: ["admin", "manager", "warehouse"],
  pos: ["admin", "manager", "cashier"],
  "bills.edit": ["admin", "manager"],
  orders: ["admin", "manager", "warehouse", "cashier"],
  reports: ["admin", "manager"],
  audit: ["admin", "manager"],
  "zepio.view": ["admin", "manager"],
  "zepio.sync": ["admin", "manager"],
  settings: ["admin"],
  users: ["admin"],
};
